module.exports = __webpack_public_path__ + "img/icon_map_jlzd_c.45d33816.png";